import { EnvironmentEnum } from '@wonderschool/common-base-types';
import { getCurrentEnvironment } from '../../../common/utils/environmentUtils';

export function getOpenLedgerUrl(externalId: string) {
  const environment = getCurrentEnvironment();
  switch (environment) {
    case EnvironmentEnum.local:
    case EnvironmentEnum.dev:
    case EnvironmentEnum.staging:
      return `https://p01--wonderschool-demo-staging--ff5w4nknvvy6.vhbq4xm4nj.code.run/?externalId=${externalId}`;
    case EnvironmentEnum.prod:
      return `https://p01--wonderschool-demo-production--ff5w4nknvvy6.vhbq4xm4nj.code.run/?externalId=${externalId}`;
    default:
      throw new Error(`Unknown environment: ${environment}`);
  }
}
